import { LinkProps, Link as MuiLink, SxProps } from '@mui/material';
import { ElementType, HTMLAttributeAnchorTarget } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { getLinkAttributes } from '../../utils/tools';

const LINK_BASE_STYLE: SxProps = {
  fontWeight: 700
};

type CustomLinkProps = LinkProps & {
  to?: string;
  target?: HTMLAttributeAnchorTarget;
  disableRipple?: boolean;
  component?: ElementType;
};

export const Link = ({
  variant = 'body1',
  to,
  href,
  target,
  children,
  disableRipple: _disableRipple,
  sx = {},
  onClick,
  component,
  ...rest
}: CustomLinkProps) => {
  const linkSx = {
    ...LINK_BASE_STYLE,
    ...sx
  };
  const componentToUse = component ?? (to ? RouterLink : 'a');
  return (
    <MuiLink
      onClick={onClick}
      variant={variant}
      component={componentToUse}
      to={to}
      href={href}
      sx={linkSx}
      {...getLinkAttributes(!to, target)}
      {...rest}
    >
      {children}
    </MuiLink>
  );
};
